module.exports = require("image-size");